import { useEffect, useState, type ReactNode, type TransitionEvent } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import styles from './AnimatedDisclosure.module.css';

/** Keeps content for the closing transition, then discards credential/form state. */
export function AnimatedDisclosure({ open, id, children }: { open: boolean; id: string; children: ReactNode }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const [mounted, setMounted] = useState(open);
  useEffect(() => {
    if (open) { setMounted(true); return; }
    // A rapid reversal can skip transitionend; still discard closed form state.
    const timeout = window.setTimeout(() => setMounted(false), reducedMotion ? 0 : 300);
    return () => window.clearTimeout(timeout);
  }, [open, reducedMotion]);
  function finishClose(event: TransitionEvent<HTMLDivElement>) {
    if (event.target === event.currentTarget && event.propertyName === 'grid-template-rows' && !open) setMounted(false);
  }
  return <div id={id} className={styles.panel} data-open={open && mounted} aria-hidden={!open}
    {...(!open ? { inert: '' } : {})} onTransitionEnd={finishClose}>
    <div className={styles.clip}>{mounted && children}</div>
  </div>;
}
